import { service } from '../../../../helpers/http'

export const ActionGetCampusesWithActiveGroups = ({ dispatch }, payload) => {
    const params = {}
    if (payload && payload.includeUpcoming) params.include_upcoming = 1
    return service({
        module: 'domainTodayLookup',
        action: 'getCampusesWithActiveGroups',
        payload: payload || {},
        params,
    })
}

export const ActionGetBlocksForCampus = ({ dispatch }, payload) => {
    return service({
        module: 'domainTodayLookup',
        action: 'getBlocksForCampus',
        payload: payload || {},
        params: { campusId: payload.campusId },
    })
}

export const ActionGetFloorsForCampus = ({ dispatch }, payload) => {
    const params = { campusId: payload.campusId }
    if (payload.blockId) params.block_id = payload.blockId
    return service({
        module: 'domainTodayLookup',
        action: 'getFloorsForCampus',
        payload: payload || {},
        params,
    })
}

export const ActionGetCoursesWithActiveGroups = ({ dispatch }, payload) => {
    const params = {}
    if (payload && payload.campusId) params.campus_id = payload.campusId
    if (payload && payload.includeUpcoming) params.include_upcoming = 1
    return service({
        module: 'domainTodayLookup',
        action: 'getCoursesWithActiveGroups',
        payload: payload || {},
        params,
    })
}

export const ActionGetGroupsByCourse = ({ dispatch }, payload) => {
    const params = { courseId: payload.courseId }
    if (payload.campusId) params.campus_id = payload.campusId
    if (payload.includeUpcoming) params.include_upcoming = 1
    return service({
        module: 'domainTodayLookup',
        action: 'getGroupsByCourse',
        payload: payload || {},
        params,
    })
}

export const ActionGetClassesTodayByCourse = ({ dispatch }, payload) => {
    const params = { courseId: payload.courseId, days: payload.days || 3 }
    if (payload.campusId) params.campus_id = payload.campusId
    return service({
        module: 'domainTodayLookup',
        action: 'getClassesTodayByCourse',
        payload: payload || {},
        params,
    })
}

export const ActionGetClassesTodayByGroup = ({ dispatch }, payload) => {
    return service({
        module: 'domainTodayLookup',
        action: 'getClassesTodayByGroup',
        payload: payload || {},
        params: { groupId: payload.groupId, days: payload.days || 3 },
    })
}

export const ActionGenerateReportAsync = ({ dispatch }, payload) => {
    return service({
        module: 'domainTodayLookup',
        action: 'generateReportAsync',
        payload: payload || {},
    })
}
